var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', [_c('v-btn', {
    staticStyle: {
      "bottom": "12px",
      "z-index": "99999"
    },
    attrs: {
      "fixed": "",
      "round": "",
      "bottom": "",
      "right": "",
      "light": "",
      "color": "grey",
      "white": "",
      "outline": "",
      "loading": _vm.isSelecting
    },
    on: {
      "click": _vm.onAttachmentButtonClick
    }
  }, [_c('v-icon', [_vm._v("attachment")])], 1), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-list', {
    staticStyle: {
      "width": "100vw",
      "max-width": "100vw"
    },
    attrs: {
      "two-line": ""
    }
  }, [_vm._l(_vm.getAttachments, function (file, key) {
    return [_c('v-list-tile', {
      key: key,
      staticClass: "d-flex",
      attrs: {
        "flat": "",
        "tile": ""
      }
    }, [file.details.type == 'image' ? _c('v-list-tile-avatar', {
      ref: 'file' + parseInt(key),
      refInFor: true,
      attrs: {
        "tile": "",
        "color": "blue"
      }
    }, [_c('img', {
      ref: 'file' + parseInt(key),
      refInFor: true,
      attrs: {
        "src": file.src
      }
    })]) : _c('v-list-tile-avatar', {
      ref: 'file' + parseInt(key),
      refInFor: true,
      attrs: {
        "tile": "",
        "color": file.details.color
      }
    }, [_c('v-icon', [_vm._v(_vm._s(file.details.icon))])], 1), _c('v-list-tile-content', [_c('v-list-tile-sub-title', {
      staticClass: "filename",
      domProps: {
        "innerHTML": _vm._s(file.name)
      }
    }), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(file.size)
      }
    })], 1), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.deleteAttachment(file);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey"
      }
    }, [_vm._v("clear")])], 1)], 1)], 1)];
  })], 2)], 1), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "multiple": "true",
      "accept": ".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"
    },
    on: {
      "change": _vm.onFileChanged
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }